import 'bootstrap/dist/css/bootstrap.min.css';
import React, { Suspense, useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme"; 

import { Amplify, Auth } from 'aws-amplify';
import { cognitoConfig } from './utils/cognito/CognitoConfig';

import { checkAppAccessibility } from './utils/accessibility-check';
import PermissionError from './Components/error/permission-error/PermissionError';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { TranslateEn } from '../src/assets/i18n/translateEn';
import { TranslateFr } from '../src/assets/i18n/translateFr';

import Layout from "./Components/Layout";
import LVCC from './Components/Pages/LVCC';
import Blocks from "./Components/Pages/Blocks";
import APIDocs from "./Components/Pages/APIDocs";
import Reports from "./Components/Pages/Reports";
import Experimental from "./Components/Pages/Experimental";
import Vitros from './Components/Pages/Vitros';
import G06 from './Components/Pages/G06';
import G06MultiIgcc from './Components/Pages/G06MultiIgcc';
import MicroSlide from './Components/Pages/MicroSlide';
import Workflow from './Components/Pages/Workflow';
import MicroTip from './Components/Pages/MicroTip';
import CalibrationReport from "./Components/Models/MicroTip/CalibrationReport";

Amplify.configure(cognitoConfig);

i18n.use(initReactI18next).init({
    resources: {
        en: { translation: TranslateEn },
        fr: { translation: TranslateFr }
    },
    lng: "en",
    fallbackLng: "en",
    interpolation: { escapeValue: false }
});


function App() {

    const [userSession, setUserSession] = useState(false);
    const [user, setUser] = useState(null);

    // use this to change languge
    const changeLang = (lang) => {
        i18n.changeLanguage(lang);
    }

    useEffect(() => {
        console.log("login loading");
        // Authenicate User
        Auth.currentAuthenticatedUser()
            .then((userInfo) => {
                console.log("User", userInfo);
                console.log("User attributes", userInfo.attributes);
                setUser(userInfo.attributes);
            })
            .catch(() => {
                console.log("Not signed in redirecting to sign in");
                Auth.federatedSignIn();
            });
        
        // Get user session and save in state
        const getSession = async () => {
            await Auth.currentSession().then(userSession => {
                setUserSession(userSession);
            });
        }
        getSession();

    }, []);

    // Check if user has permission to access the page
     const canUserAccess = () => {
        return checkAppAccessibility(user?.['custom:UserType']);
    }
    // signout function
    const cognitoSignOut = () => {
        Auth.signOut();
    }

    // return application component when login is valid
    if (userSession && userSession?.isValid()) {

        return (
            user && canUserAccess() ?
                <Suspense fallback="loading...">
                    <div>
                        <ThemeProvider theme={theme}> {/* Wrap app with ThemeProvider */}
                            <CssBaseline /> {/* Normalizes styles for consistent look */}
                            <Router>
                                <Routes>
                                    {/* Layout wraps all pages and uses <Outlet> */}
                                    <Route path="/" element={<Layout signout={cognitoSignOut} user={user} />}>
                                        <Route index element={<LVCC />} />
                                        <Route path="blocks" element={<Blocks />} />
                                        <Route path="lvcc" element={<LVCC />} />
                                        <Route path="vitros" element={<Vitros />} />
                                        <Route path="Workflow" element={<Workflow />} />
                                        <Route path="G06" element={<G06 />} />
                                        <Route path="G06MultiIgcc" element={<G06MultiIgcc />} />
                                        <Route path="MicroTip" element={<MicroTip />} />
                                        <Route path="microslide" element={<MicroSlide />} />
                                        <Route path="api-docs" element={<APIDocs />} />
                                        <Route path="reports" element={<Reports />} />
                                        <Route path="experimental" element={<Experimental />} />
                                        <Route path="/CalibrationReport" element={<CalibrationReport />} />
                                    </Route>
                                </Routes>
                            </Router>
                        </ThemeProvider>
                        );                       
                    </div>
                </Suspense>
                : <PermissionError />
        );

    } else {

        // Navigate to signin if login is not valid
        return (
            <div>
                You will be automatically redirected or{" "}
                <a href="#" onClick={Auth.federatedSignIn}>
                    click here to login
                </a>
            </div>
        );

    }
}

export default App;